import { SlideFade } from '@chakra-ui/react';
import { DataProps, QBox, QCounter, QStack } from '../../..';
import { QText } from '../../../QAtoms';
import React from 'react';
import { useSelectionMaybe } from '../Selecting';

type QDataTableActionBarProps = {
  children: React.ReactNode;
} & DataProps;

export const QDataTableActionBar: React.FC<QDataTableActionBarProps> = ({
  children,
  ...rest
}) => {
  const selections = useSelectionMaybe();

  const selectedCount = Object.keys(selections?.selection ?? {}).length;

  return (
    <QBox
      position="fixed"
      bottom={0}
      left="50%"
      transform="translateX(-50%)"
      pointerEvents="none"
      pb={6}
      {...rest}
    >
      <SlideFade
        in={selectedCount > 0}
        offsetY={16}
        transition={{ enter: { duration: 0.3 } }}
      >
        <QBox
          bg="blue.900"
          backdropFilter="blur(16px)"
          borderWidth="1px"
          borderColor="gray.700"
          borderRadius="full"
          boxShadow="0 20px 25px -5px rgba(0, 0, 0, 0.3), 0 10px 10px -5px rgba(0, 0, 0, 0.2)"
          pointerEvents="auto"
          width="fit-content"
        >
          <QStack direction="row" align="center" px={6} py={4}>
            <QStack direction="row" align="center">
              <QCounter count={selectedCount} size="md" variant="blue" />
              <QText fontSize="sm" fontWeight="medium" color="white">
                selected
              </QText>
            </QStack>
            {children}
          </QStack>
        </QBox>
      </SlideFade>
    </QBox>
  );
};
